import { useState } from "react";
import { unwrapPayload } from "../../utilities";
import { Alert, Button } from "reactstrap";

export function AccountsDiagnosticsSection
(
    {
        getGoogleMerchantAccounts
    }
    :
    {
        getGoogleMerchantAccounts: () => Promise<any>
    }
)
{
    const [accountsResponse, setAccountsResponse] = useState<any | null>(null);
    const [error, setError] = useState<string | null>(null);

    const loadAccounts = async () =>
    {
        setError(null);

        try
        {
            const result = await getGoogleMerchantAccounts();
            setAccountsResponse(unwrapPayload(result));
        }
        catch (exception: any)
        {
            setError(exception?.message ?? 'Pobieranie kont Merchant zakończyło się błędem.');
        }
    };

    return (
        <section className="mt-5">
            <h5>Konta Merchant Center</h5>

            {error && <Alert color="danger">{error}</Alert>}

            <div className="d-flex justify-content-end">
                <Button type="button" color="secondary" onClick={loadAccounts}>
                    Pobierz konta
                </Button>
            </div>

            {accountsResponse && (
                <details className="mt-4" open>
                    <summary>Raw JSON</summary>
                    <pre className="mt-3">{JSON.stringify(accountsResponse, null, 2)}</pre>
                </details>
            )}
        </section>
    );
}